import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ErrorMessage from '../_components/ErrorMessage';
import { BusinessProfileActions } from '../_actions';
import { ModalCreateUser_VALIDATIONS } from '../_validations/modalValidations';
import { ToastContainer, toast } from 'react-toastify';

function ModalCreateUser({ handleClose, show }) {
  const dispatch = useDispatch();
  const registering = useSelector(
    (state) => state.businessProfileReducers.isLoadingModal
  );
  const formSchema = Yup.object().shape({ ...ModalCreateUser_VALIDATIONS });
  const validationOpt = {
    resolver: yupResolver(formSchema),
  };
  const { register, handleSubmit, reset, formState } = useForm(validationOpt);
  const { errors } = formState;

  function onFormSubmit(data) {
    dispatch(BusinessProfileActions.CreateUser(data, reset, toast));
  }

  function resetForm() {
    handleClose();
  }

  return (
    <>
      <ToastContainer autoClose={false} theme="colored" />
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-filters"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="text-center">Nuevo usuario</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
              <div className="row">
                <div className="">
                  <div
                    className={
                      'form-group half-minus-10-right' +
                      (errors.first_name ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="first_name">Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      name="first_name"
                      disabled={registering}
                      {...register('first_name')}
                      placeholder="Nombre"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.first_name} />
                  </div>
                  <div
                    className={
                      'form-group half-minus-10-right' +
                      (errors.last_name ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="last_name">Apellido</label>
                    <input
                      type="text"
                      className="form-control"
                      name="last_name"
                      disabled={registering}
                      {...register('last_name')}
                      placeholder="Apellido"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.last_name} />
                  </div>
                  <div
                    className={
                      'form-group half-minus-10-right' +
                      (errors.email ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="email">Correo electronico</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      disabled={registering}
                      {...register('email')}
                      placeholder="Correo electronico"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.email} />
                  </div>
                  <div
                    className={
                      'form-group half-minus-10-right' +
                      (errors.role ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="role">Rol en la empresa</label>
                    <input
                      type="text"
                      className="form-control"
                      name="role"
                      disabled={registering}
                      {...register('role')}
                      placeholder="Rol en la empresa"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.role} />
                  </div>
                  <div
                    className={
                      'form-group half-minus-10-left' +
                      (errors.user_type ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="user_type">Permisos</label>
                    <select
                      type="text"
                      className="form-control"
                      name="user_type"
                      disabled={registering}
                      {...register('user_type')}
                      placeholder="Permisos"
                      autoComplete="off"
                    >
                      <option></option>
                      <option value="CMS Admin">CMS Admin</option>
                      <option value="CMS User">CMS User</option>
                    </select>
                    <ErrorMessage error={errors.user_type} />
                  </div>
                </div>
              </div>
              <div className="text-right buttons">
                <button
                  type="button"
                  className="btn btn-white-bg"
                  disabled={registering}
                  onClick={resetForm}
                >
                  Cancelar
                </button>
                <button className="btn btn-primary" disabled={registering}>
                  Aplicar
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalCreateUser;
